import { useState, useEffect } from "react";

import { useFaq } from "context/client/faq";

const STORAGE_KEY = "most-searched-indices";
const MAX_ITEMS = 8;

const useMostSearched = () => {
  const { data } = useFaq();

  const [shuffledIndices, setShuffledIndices] = useState([]);

  useEffect(() => {
    const savedIndices = localStorage.getItem(STORAGE_KEY);

    if (savedIndices && JSON.parse(savedIndices).length > 0) {
      setShuffledIndices(JSON.parse(savedIndices));
    } else if (data.length > 0) {
      const indices = Array.from({ length: data.length }, (_, i) => i);

      for (let i = indices.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [indices[i], indices[j]] = [indices[j], indices[i]];
      }

      const slicedIndices = indices.slice(0, Math.min(MAX_ITEMS, data.length));

      localStorage.setItem(STORAGE_KEY, JSON.stringify(slicedIndices));
      setShuffledIndices(slicedIndices);
    }
  }, [data.length]);

  return { data, shuffledIndices, MAX_ITEMS };
};

export default useMostSearched;
